import { Injectable } from '@angular/core';
import {ControllerRequest} from "./controller-request";
import {RequestRegistry} from "./request-registry";
import {ControllerQuery} from "./controller-query";
import {ControllerView} from "./controller-view";
import { UserService } from '../user/user.service';
import { UtilService } from '../util/util.service';
import {HttpClient} from "@angular/common/http";
import {FeatureFlagsService} from "../feature-flag/feature-flags.service";
import {EventService} from "../event/event.service";

@Injectable({
  providedIn: 'root'
})
export class RequestService {

  private requestRegistry;

  constructor(private userService: UserService,
              private utilService: UtilService,
              private http: HttpClient,
              private featureFlagsService: FeatureFlagsService,
              private eventService: EventService) {
    (window as any).NG_SHARED_REQUEST_SERVICE = this;
    this.requestRegistry = new RequestRegistry(eventService);
  }

  createRequest(): ControllerRequest {
    return new ControllerRequest(this.requestRegistry, this.userService, this.utilService, this.http, this.featureFlagsService, this.eventService);
  }

  createControllerQuery(): ControllerQuery {
    return new ControllerQuery();
  }

  createView(): ControllerView {
    return new ControllerView();
  }
}
